if (!customElements.get("product-form")) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector("form");
      if (this.form.querySelector("[name=id]"))
        this.form.querySelector("[name=id]").disabled = false;
      this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
      this.cart =
        document.querySelector("cart-notification") ||
        document.querySelector("cart-drawer");
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector("cart-drawer"))
        this.submitButton.setAttribute("aria-haspopup", "dialog");
      this.variantForm =
        this.closest(".product")?.querySelector("variant-form");
    }

    async onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute("aria-disabled") === "true") return;

      this.handleErrorMessage();

      this.submitButton.setAttribute("aria-disabled", true);
      this.submitButton.classList.add("loading");
      this.querySelector(".loading-overlay__spinner").classList.remove(
        "hidden"
      );

      const config = fetchConfig("javascript");
      config.headers["X-Requested-With"] = "XMLHttpRequest";
      delete config.headers["Content-Type"];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append(
          "sections",
          this.cart.getSectionsToRender().map((section) => section.id)
        );
        formData.append("sections_url", window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }

      if (this.variantForm) {
        config.body = this.setVariantFormData(formData);
      } else {
        config.body = formData;
      }

      try {
        await this.addProductToCart(config);

        if (this.checkGwpEnabled()) {
          const cartData = await this.getCartData();
          this.addGwpItem(cartData, config);
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.submitButton.classList.remove("loading");
        if (this.cart && this.cart.classList.contains("is-empty"))
          this.cart.classList.remove("is-empty");
        if (!this.error) this.submitButton.removeAttribute("aria-disabled");
        this.querySelector(".loading-overlay__spinner").classList.add("hidden");
        if (this.variantForm) this.variantForm.resetQuantities();
      }
    }

    async addProductToCart(config) {
      try {
        const request = await fetch(`${routes.cart_add_url}`, config);
        const response = await request.json();
        if (response.status) {
          this.handleErrorMessage(response.description);

          const soldOutMessage =
            this.submitButton.querySelector(".sold-out-message");
          if (!soldOutMessage) return;
          this.submitButton.setAttribute("aria-disabled", true);
          this.submitButton.querySelector("span").classList.add("hidden");
          soldOutMessage.classList.remove("hidden");
          this.error = true;
          return;
        } else if (!this.cart) {
          window.location = window.routes.cart_url;
          return;
        }

        this.error = false;
        const quickAddModal = this.closest("quick-add-modal");
        const shopTheLookModal = this.closest("modal-dialog");
        if (quickAddModal || shopTheLookModal) {
          document.body.addEventListener(
            "modalClosed",
            () => {
              setTimeout(() => {
                this.cart.renderContents(response);
              });
            },
            { once: true }
          );
          if (quickAddModal) {
            quickAddModal.hide(true);
          } else {
            shopTheLookModal.hide(true);
          }
        } else {
          this.cart.renderContents(response);
        }
      } catch (e) {
        console.error(e);
      }
    }

    async getCartData() {
      const request = await fetch(window.Shopify.routes.root + "cart.js");
      const response = await request.json();
      return response;
    }

    async addGwpItem(cart, config) {
      const { enable, variants, cartSubtotalMin, hasBuyProduct } = window.gwp;
      const gwpVariant = variants.filter((v) => v.available)[0];
      // TEMP: Allowed multiple gwp for dec 2024 promo
      // const gwpInCart = cart.items.find((item) => item.id === gwpVariant.id);
      const gwpInCart = false;
      const gwpMinMet = cart.items_subtotal_price >= cartSubtotalMin;

      if (!enable || gwpInCart || !gwpMinMet || !hasBuyProduct) {
        return;
      }

      let gwpData = {
        items: [
          {
            id: gwpVariant.id,
            quantity: 1,
          },
        ],
        sections: this.cart.getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname,
      };
      config.body = gwpData;

      const request = await fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(gwpData),
      });
      const response = await request.json();
      this.cart.renderContents(response);
    }

    checkGwpEnabled() {
      return window.gwp?.enable;
    }

    setVariantFormData(formData) {
      const items = this.variantForm.items;
      formData.delete("id");
      const newFormData = this.buildFormData(formData, "items", items);
      return newFormData;
    }

    buildFormData(formData, key, data) {
      if (data === Object(data) || Array.isArray(data)) {
        for (const i in data)
          this.buildFormData(formData, `${key}[${i}]`, data[i]);
      } else {
        data && formData.append(key, data);
      }
      return formData;
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper =
        this.errorMessageWrapper ||
        this.querySelector(".product-form__error-message-wrapper");
      if (!this.errorMessageWrapper) return;
      this.errorMessage =
        this.errorMessage ||
        this.errorMessageWrapper.querySelector(".product-form__error-message");

      this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  }

  customElements.define("product-form", ProductForm);
}
